// Types
import type { LocaleProps } from '@/types/config/locale'

// Configurations
import Config from '@/config'

const LocaleConfig: LocaleProps = {
	default: process.env.APP_LOCALE_DEFAULT ?? 'fa',
	list: process.env.APP_LOCALE_LIST ? process.env.APP_LOCALE_LIST.split(',') : ['fa', 'en'],
	cookieName: `${Config.shortName.toLocaleLowerCase()}-locale`
}

export default LocaleConfig
